import React from "react";
import { SecondaryButton } from "@prestosports/commons-ui";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

const CsvDownloadButton = ({
	csvContent = "",
	filename = "sport_sample.csv",
	label = "Download Sample File"
}) => {
	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
	const csvUrl = URL.createObjectURL(blob);

	return (
		<SecondaryButton
			size="medium"
			label={label}
			download={filename}
			startIcon={<DescriptionOutlinedIcon />}
			href={csvUrl}
		/>
	);
};

export default CsvDownloadButton;
